'use client'
import { sanitizeName } from '@dynamic-labs/utils';
import { InjectedWalletBase } from '../../injected/InjectedWalletBase.js';

const getConnectorConstructorForEip6963Wallet = (walletDetail) => {
    const { info, provider } = walletDetail;
    const sanitizedName = sanitizeName(info.name);
    return class extends InjectedWalletBase {
        constructor(props) {
            super(Object.assign(Object.assign({}, props), { metadata: {
                    groupKey: sanitizedName,
                    icon: info.icon,
                    id: info.uuid,
                    name: info.name,
                    rdns: info.rdns,
                } }));
            this.name = info.name;
            this.overrideKey = `${sanitizedName}evm`;
        }
        findProvider() {
            return provider;
        }
    };
};

export { getConnectorConstructorForEip6963Wallet };
